import { ContactInfo } from '@/models';

export interface CmhContactState {
  contactInfo: ContactInfo | null
}

export const InitialState: CmhContactState = {
  contactInfo: null
}
